export default "__VITE_ASSET__DrLcGpKe__"